import React, { Component } from "react";
import { Grid, Row, Col, Media, FormControl, FormGroup } from "react-bootstrap";

import UserCard from "../../components/Card/UserCard.jsx";

import Button from "../../components/CustomButton/CustomButton.jsx";

import avatar from "../../assets/img/logo_white_transparent.png";
import bgCardPrimary from "../../assets/img/card-primary.png";
import bgCardDanger from "../../assets/img/card-danger.png";
import bgCardInfo from "../../assets/img/card-info.png";
import bgCardSuccess from "../../assets/img/card-success.png";
import bgCardWarning from "../../assets/img/card-warning.png";
import bgImage from "../../assets/img/matrix-old.jpg";
import {NavLink} from "react-router-dom";
import rest from "../../API/api";


class PricingPage extends Component {

  render() {
    return (
      <Grid>
        <Row>
          <Col md={8} mdOffset={2}>
            <div className="header-text">
              <h2>Our Pricing Plans</h2>
              <h4>Pick the best Plan for you!</h4>
              <hr />
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg="4" md="7">
            <UserCard
                bgImage={bgCardPrimary}
                avatar={avatar}
                name="Monthly"
                userName="Monthly Plan Details"
                description={
                  <span>
                      <br />
                      Up to 3 Kiosk Stations
                     <br />
                      3 Years of Online Consent Form Storage Included
                    <br />
                    Based on Usage
                      <br />
                    <h5>Starting at: ${rest.Monthly} / month</h5>
                      <br />
                      <NavLink to={"/register"} className="nav-link">
                          <Button bsStyle="primary"  round fill wd>
                          Get Started
                          </Button>
                      </NavLink>
                  </span>

                }
            />
          </Col>
          <Col lg="4" md="7">
            <UserCard
                bgImage={bgCardInfo}
                avatar={avatar}
                name="Full Year Plan"
                userName="Full Year Plan Details"
                description={
                  <span>
                      <br />
                      Up to 3 Kiosk Stations
                      <br />
                      3 Years of Online Consent Form Storage Included
                    <br />
                    Based on Usage
                      <br />
                      <b><i>*Best Value*  Save 10% per Year </i></b>
                    <h5>Starting at: ${rest.Yearly} / year</h5>
                      <NavLink to={"/register"} className="nav-link">
                          <Button bsStyle="primary"  round fill wd>
                          Get Started
                          </Button>
                      </NavLink>
                  </span>

                }
            />
          </Col>
          <Col lg="4" md="7">
            <UserCard
                bgImage={bgCardWarning}
                avatar={avatar}
                name="Multi-Shop"
                userName="Multi-Shop Plan Details"
                description={
                  <span>
                      <br />
                      Add-on to a Monthly or Yearly Plan
                      <br />
                      Run Multiple Shops From One Tenant Account
                     <br />
                      3 Years of Online Consent Form Storage Included
                    <br />
                    Based on Usage
                    <br />
                    <h5>Starting at: ${rest.MultiShop} / month per location</h5>
                      <NavLink to={"/register"} className="nav-link">
                          <Button bsStyle="primary"  round fill wd>
                          Get Started
                          </Button>
                      </NavLink>
                  </span>

                }
            />
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default PricingPage;



// WEBPACK FOOTER //
// ./src/views/Pages/PricingPage.jsx